import type {
	ClientAddressEntity,
	PortalAccountDeletionResultDto,
	PortalProfileDto,
	PortalProfileUpdateDto,
	PortalSalesRepInfoDto,
} from '@supply-mover-2-0/shared';
import { portalFetch } from '../lib/apiClient';

/**
 * Fetch the portal user's profile.
 */
export async function getProfile(token: string): Promise<PortalProfileDto> {
	return portalFetch<PortalProfileDto>('/account/profile', token);
}

/**
 * Update the portal user's profile.
 */
export async function updateProfile(
	token: string,
	payload: PortalProfileUpdateDto,
): Promise<PortalProfileDto> {
	return portalFetch<PortalProfileDto>('/account/profile', token, {
		method: 'PUT',
		body: JSON.stringify(payload),
	});
}

/**
 * Delete the signed-in user's own account (PD-16721): their login and personal
 * details. The customer account and its orders, invoices and payments are kept.
 */
export async function deleteAccount(
	token: string,
): Promise<PortalAccountDeletionResultDto> {
	return portalFetch<PortalAccountDeletionResultDto>('/account', token, {
		method: 'DELETE',
	});
}

/**
 * Fetch addresses for the active client.
 */
export async function getAddresses(
	token: string,
): Promise<Array<ClientAddressEntity>> {
	return portalFetch<Array<ClientAddressEntity>>('/account/addresses', token);
}

/**
 * Fetch the assigned salesperson contact info for the active client
 * (PD-15235). Null when the portal site opts out or no rep is assigned —
 * callers hide the block.
 */
export async function getSalesRepInfo(
	token: string,
): Promise<PortalSalesRepInfoDto | null> {
	return portalFetch<PortalSalesRepInfoDto | null>('/account/sales-rep', token);
}
